import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { FilterButton } from '@sorare/core/src/components/search/FilterButton';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import useLifecycle, {
  LIFECYCLE,
  Lifecycle,
} from '@sorare/core/src/hooks/useLifecycle';

import useFiltersCount from 'search/FiltersManager/useFiltersCount';

import { useShowEuropeanChampionshipTooltip } from './useShowEuropeanChampionshipTooltip';

const CustomTooltip = styled(Horizontal).attrs({ gap: 0.5 })`
  isolation: isolate;
  position: relative;
`;

const EuropeanChampionshipCtn = styled.div`
  width: 280px;
  position: absolute;
  padding: var(--unit);
  bottom: calc(100% + var(--unit));
  left: calc(50% - 140px);
  background-color: var(--c-neutral-300);
  border-radius: var(--unit);
  border: #7724ff solid 1px;
  &::after {
    content: '';
    position: absolute;
    display: block;
    width: var(--intermediate-unit);
    height: var(--unit);
    background-color: #7724ff;
    clip-path: polygon(100% 0, 0 0, 50% 100%);
    bottom: calc(-1 * var(--unit));
    left: calc(50%);
  }
`;

const EuropeanChampionship = styled(BodyS)`
  text-align: center;
  background: linear-gradient(28deg, #7724ff 21.95%, #f3d0dd 109.77%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
interface ToggleFiltersManagerProps {
  toggleFilters: () => void;
}

export const ToggleFiltersManager = ({
  toggleFilters,
}: ToggleFiltersManagerProps) => {
  const {
    flags: { useEuroChampionshipToggle },
  } = useFeatureFlags();
  const filtersCount = useFiltersCount();
  const { update } = useLifecycle();
  const { currentUser } = useCurrentUserContext();
  const lifecycle = currentUser?.userSettings?.lifecycle as Lifecycle;
  const showEuropeanChampionshipTooltip = useShowEuropeanChampionshipTooltip();
  const { sawEuropeanChampionshipTooltip } = lifecycle || {};

  const btn = (
    <FilterButton
      onClick={() => {
        toggleFilters();
        if (!sawEuropeanChampionshipTooltip)
          update(LIFECYCLE.sawEuropeanChampionshipTooltip, true);
      }}
      filtersCount={filtersCount}
    />
  );

  // REMOVE ME - AFTER 2024-07-01 EOD
  // LINEAR [MAR-810]
  if (
    !sawEuropeanChampionshipTooltip &&
    showEuropeanChampionshipTooltip &&
    useEuroChampionshipToggle
  ) {
    return (
      <CustomTooltip>
        <EuropeanChampionshipCtn
          onClick={() => {
            update(LIFECYCLE.sawEuropeanChampionshipTooltip, true);
          }}
        >
          <EuropeanChampionship>
            <FormattedMessage
              id="search.filters.europeanChampionship.tooltip"
              defaultMessage="New filter available for the European Championship!"
            />
          </EuropeanChampionship>
        </EuropeanChampionshipCtn>
        {btn}
      </CustomTooltip>
    );
  }
  return btn;
};

export default ToggleFiltersManager;
